export default __webpack_public_path__ + "static/media/hazem.4694db32.png";